/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeagueDivisionResponse
 */
export interface LeagueDivisionResponse {
    /**
     * 
     * @type {string}
     * @memberof LeagueDivisionResponse
     */
    divisionId: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueDivisionResponse
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof LeagueDivisionResponse
     */
    tier: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueDivisionResponse
     */
    promotionSpots?: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueDivisionResponse
     */
    relegationSpots?: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueDivisionResponse
     */
    playoffSpots?: number;
}

/**
 * Check if a given object implements the LeagueDivisionResponse interface.
 */
export function instanceOfLeagueDivisionResponse(value: object): value is LeagueDivisionResponse {
    if (!('divisionId' in value) || value['divisionId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('tier' in value) || value['tier'] === undefined) return false;
    return true;
}

export function LeagueDivisionResponseFromJSON(json: any): LeagueDivisionResponse {
    return LeagueDivisionResponseFromJSONTyped(json, false);
}

export function LeagueDivisionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeagueDivisionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'divisionId': json['divisionId'],
        'name': json['name'],
        'tier': json['tier'],
        'promotionSpots': json['promotionSpots'] == null ? undefined : json['promotionSpots'],
        'relegationSpots': json['relegationSpots'] == null ? undefined : json['relegationSpots'],
        'playoffSpots': json['playoffSpots'] == null ? undefined : json['playoffSpots'],
    };
}

export function LeagueDivisionResponseToJSON(json: any): LeagueDivisionResponse {
    return LeagueDivisionResponseToJSONTyped(json, false);
}

export function LeagueDivisionResponseToJSONTyped(value?: LeagueDivisionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'divisionId': value['divisionId'],
        'name': value['name'],
        'tier': value['tier'],
        'promotionSpots': value['promotionSpots'],
        'relegationSpots': value['relegationSpots'],
        'playoffSpots': value['playoffSpots'],
    };
}

